import gql from 'graphql-tag';

export const GET_DELIVERY_LIST = gql`
query(
    $golf_group_code: String
    $golf_code: String
    $toDay: String
    $endDay: String
    $vue_id: String
    $element_id: String
){
    getDeliveryList(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        toDay: $toDay
        endDay: $endDay
        vue_id: $vue_id
        element_id: $element_id
    ){
        GolfCode
        GolfSelect{
            golf_code
            golf_name
        }
        OperationAccessList{
            user_div
            vue_id
            vue_name
            element_id
            element_name
            element_control
            display_control
        }
        DeliveryList{
            delivery_id
            delivery_date
            delivery_contents
            valid_flag
        }
    }
}
`;

export const REGISTER_DELIVERY = gql`
mutation(
    $golf_code: String
    $delivery_id: Int
    $delivery_date: String
    $delivery_contents: String
){
    RegisterDelivery(
        golf_code: $golf_code
        delivery_id: $delivery_id
        delivery_date: $delivery_date
        delivery_contents: $delivery_contents
    ){
        result
    }
}
`;

export const UPDATE_DELIVERY = gql`
mutation(
    $golf_code: String
    $delivery_id: Int
    $delivery_date: String
    $delivery_contents: String
){
    UpdateDelivery(
        golf_code: $golf_code
        delivery_id: $delivery_id
        delivery_date: $delivery_date
        delivery_contents: $delivery_contents
    ){
        result
    }
}
`;

export const DELETE_DELIVERY = gql`
mutation(
    $golf_code: String
    $delivery_id: Int
    $delivery_date: String
    ){
    DeleteDelivery(
        golf_code: $golf_code
        delivery_id: $delivery_id
        delivery_date: $delivery_date
    ){
        result
    }
}
`;
